import type { WordListData, WordListEntry } from '@/teoCore/TeoApi';
import { TeoEventTarget } from '@/teoCore/utility/TeoEventTarget';

import type { TeoText } from '../TeoText';
import type { UiWordListEntry, WordListHandler } from './WordListHandler';
import { WordListSubHandler, type WordListSubHandlerEvents } from './WordListSubHandler';

export class DictionaryHandler extends WordListSubHandler {
  passed: boolean | undefined;
  constructor(wordLists: WordListHandler, text: TeoText) {
    super(
      wordLists,
      text,
      new TeoEventTarget<WordListSubHandlerEvents>(),
      'dictionary',
      'dictionaryWordList',
      'dictionaryCategory',
    );
    this.relationOffset = 300000;
    this.events.addEventListener('gotScanResult', (result) => {
      this.lists = [];
      result.word_lists.forEach((wordList) => {
        if (!wordList.use_for_ct && wordList.relation_type !== 4) {
          this.lists.push(wordList);
        }
      });
      console.log('DictionaryHandler gotScanResult', this.lists);
      this.syncCurrentEntries();
    });

    this.text.store.addEventListener('view', (viewName: string) => {
      if (
        viewName === 'dictionary' &&
        this.text.analysisState.canAnalyze &&
        !this.text.analysisState.dictionaryUpToDate
      ) {
        this.text.analyze({ trigger: null });
      }
    });
  }

  override async scan(): Promise<void> {
    await super.scan('dictionary');
  }

  protected override createUiWordListEntry(
    entry: WordListEntry,
    wordList: WordListData,
  ): UiWordListEntry {
    const uiEntry = super.createUiWordListEntry(entry, wordList);
    uiEntry.cardLabel = wordList.title;
    return uiEntry;
  }

  protected override syncSelectedLists(): void {
    const selectedCategory = this.text.ui.state[this.uiCategoryName];
    const selectedWordList = this.text.ui.state[this.uiWLName] || selectedCategory;
    if (selectedWordList) {
      const list = this.lists.find((l) => l.name === selectedWordList);
      if (list) {
        this.selectLists([list.id]);
        this.unFocusEntry();
      } else {
        console.warn('Word list not found:', selectedWordList);
        this.selectLists([]);
      }
    } else {
      this.selectLists([]);
      this.unFocusEntry();
    }
  }
}
